// Reading an Engagements record.
//
// Identity is never stored on the engagement row — Organisation and Key
// Contact are links to the spine, and the portal reads them through lookup
// fields. Airtable returns lookups as arrays, so these helpers unwrap them.

const first = v => (Array.isArray(v) ? v[0] : v) || "";

export const orgName = fields => first(fields["Org Name"]);
export const contactName = fields => first(fields["Contact Name"]);
export const contactEmail = fields => first(fields["Contact Email"]);
export const contactFirstName = fields => contactName(fields).split(" ")[0];
